<div class="card" *ngIf="type === 'web-info'">
    <div class="card-header mb-2">
        <span>Website Information</span>
    </div>
    <div class="surface-section">
        <ul class="list-none p-0 m-0">
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">Target</div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="wrap-text text-900">
                        {{data?.target ?? 'Not Found'}}</div>
                </div>
            </li>
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">Crawled Pages</div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="text-900">
                        {{data?.crawledPages | number:'1.0':'en-US' ?? 'Not Found'}}</div>
                </div>
            </li>
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">CMS</div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="wrap-text text-900">
                        {{data?.info?.cms ?? 'Not Found'}}</div>
                </div>
            </li>
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">IP</div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="text-900">
                        {{data?.info?.ipSddress ?? 'Not Found'}}</div>
                </div>
            </li>
        </ul>
    </div>
</div>
<div class="card" *ngIf="type === 'referring-domain'">
    <div class="card-header mb-2">
        <span>Referring Page</span>
    </div>
    <div class="surface-section">
        <ul class="list-none p-0 m-0">
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">Referring pages
                    <i class="pi pi-info-circle ml-2" tooltipPosition="right" pTooltip="{{'siteSearchScreens.overview.referringPages.pages' | translate}}" ></i>
                </div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="text-900">
                        {{data?.referringPages | number:'1.0':'en-US' ?? 'Not Found'}}</div>
                </div>
            </li>
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">Referring IPs
                    <i class="pi pi-info-circle ml-2" tooltipPosition="right" pTooltip="{{'siteSearchScreens.overview.referringPages.ips' | translate}}" ></i>
                </div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="text-900">
                        {{data?.referringIps | number:'1.0':'en-US' ?? 'Not Found'}}</div>
                </div>
            </li>
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">Referring subnets
                    <i class="pi pi-info-circle ml-2" tooltipPosition="right" pTooltip="{{'siteSearchScreens.overview.referringPages.subnets' | translate}}" ></i>
                </div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="text-900">
                        {{data?.referringSubnets | number:'1.0':'en-US' ?? 'Not Found'}}</div>
                </div>
            </li>
        </ul>
    </div>
</div>

<div class="card" *ngIf="type === 'organicMetric'">
    <div class="surface-section">
        <ul class="list-none p-0 m-0" *ngFor="let key of objectKeys(data)">
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">{{ formatHeader(key) }}</div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="wrap-text text-900">
                        {{ data[key] | number:'1.0-0':'en-US' }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
<div class="card" *ngIf="type === 'paidMetric'">
    <div class="surface-section">
        <ul class="list-none p-0 m-0" *ngFor="let key of objectKeys(data)">
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-6 font-medium">{{ formatHeader(key) }}</div>
                <div class="w-6 md:w-5 flex justify-content-end">
                    <div class="wrap-text text-900">
                        {{ data[key] | number:'1.0-0':'en-US' }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
